import Urls from "@/common/urls";
import Apiroot from "@/common/apiroot";
import axios from "axios";

const userStore = {
  state: {
    loginSuccess: false,
    loginError: false,
    userEmail: null,
    userName: null,
    userCode: null,
    trackingCode: null,
    apiKey: null,
    siteCode: null,

    trackAppModal : false,
    trackOrApi : 0,
    payModal : false,
    itemPrice : 0,

    testData : [],

    userAuthModal : false,

  },
  getters : {
    getUserCode(state){

      if(state.userCode == null){
        location.href = "/"
        return ;
      } else {
        return state.userCode;

      }

    },
    getPayModal(state){
      return state.payModal;
    }
  },
  mutations: {
    loginSuccess(state, { email, code, name }) {
      console.log("mutation", this.email);
      state.loginSuccess = true;
      state.userEmail = email;
      state.userCode = code;
      state.userName = name;
    },
    setUserNickName(state, { name }) {
      state.loginSuccess = true;
      state.userName = name;
    },
    loginError(state, { email }) {
      state.loginError = true;
      state.userEmail = email;
    },
    logout(state) {
      state.loginSuccess = false;
      state.loginError = false;
      state.userEmail = null;
      state.userName = null;
      state.userCode = null;
      state.trackingCode = null;
      state.apiKey = null;
      state.trackAppModal = false;
      state.siteCode = null;

      location.href="/"
    },
    setModal(state, {setModal}) {
      console.log(setModal)
      state.userAuthModal = setModal;
    },
    setPayModal(state, {modalStatus, itemPrice}) {
      console.log(modalStatus)
      state.payModal = modalStatus;
      state.itemPrice = itemPrice;
    },
  },
  actions: {
    getPayModal : function({commit}, {state, price}){
      commit("setPayModal", {modalStatus : state, itemPrice : price});

    },
    setUserName : function({commit}, {name}){
      commit("setUserNickName", {name : name});
    },
    getUserAuthModal : function ({commit}, {state}) {
      var text = false;
      if(state == 0){
        text = true;
      }
      console.log(state)
      commit("setModal", {
        setModal: text,
      });

      // return !state.userAuthModal;
    },
    async login({ commit }, { email, password }) {
      try {
        console.log("store : ", email, password);
        const result = await axios.post(
          Apiroot.company + Urls.login,

          {
            userEmail: email,
            userPw: password,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // alert(result)
        console.log(result);
        if (result.status == 200) {
          if (result.data["code"] == 0) {
            if (result.data["user"].deleteYn == "N") {
              this.loginSuccess = true;
              this.userEmail = result.data.user.userEmail;
              console.log(this.userEmail);
              commit("loginSuccess", {
                email: this.userEmail,
                code: result.data.user.userCode,
                name: result.data.user.userName,
              });
            }
            // alert("로그인 성공", email)
          }
          return result;
          //  else if(result.data['code'] == 10002) {
          //   alert('탈퇴된 계정입니다.')

          // } else {
          //   alert('아이디나 비밀번호가 틀립니다')
          // }
        }
      } catch (err) {
        alert("로그인에 실패했습니다.");
        commit("loginError", {
          userEmail: email,
        });
        throw new Error(err);
      }
    },
    async logout({ commit }) {
      const result = await axios.post(
        Apiroot.company + Urls.logout,
        {
          userCode: this.code,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // alert(result)
      console.log(result);
      //  if (result.status == 200) {
      //    if(result.data['code'] == 0){
      //        alert("ddddddddddd")

      commit("logout");

      //  }

      //  }
    },
  },
};

export default userStore;
